import {
  CASHIER_TRANSACTION_COLUMNS,
  GALAXY_TRANSACTION_COLUMNS,
  ORDER_DETAILS_COLUMNS,
  CASHIER_REFUND_COLUMNS,
  SEARCH_DB,
  GALAXY_REFUND_COLUMNS,
  DATA_TYPE,
} from './payment-search.constants';

export const getColumns = (type, database) => {
  if (type === DATA_TYPE.ORDER) {
    return ORDER_DETAILS_COLUMNS;
  }
  if (type === DATA_TYPE.PAYMENT_TRANSACTION) {
    if (database === SEARCH_DB.CASHIER) return CASHIER_TRANSACTION_COLUMNS;
    if (database === SEARCH_DB.GALAXY) return GALAXY_TRANSACTION_COLUMNS;
  }
  if (type === DATA_TYPE.REFUND_TRANSACTION) {
    if (database === SEARCH_DB.CASHIER) return CASHIER_REFUND_COLUMNS;
    if (database === SEARCH_DB.GALAXY) return GALAXY_REFUND_COLUMNS;
  }

  return [];
};

export default getColumns;
